import {ReactNode} from "react";

import {useRoutedModalState} from "../../../../hooks/use_routed_modal_state";
import {getPlanner3dData} from "../../../constants/get_planner_3d_data";
import {PLANNER_3D_SEARCH_PARAM} from "../../constants/planner_3d_params";
import {YslabProperty} from "./api/yslab_investments_api";
import {useYslabPlannerPropertyData} from "./hooks/use_yslab_planner_property_data";
import {YslabPlanner3dModal} from "./Planner3DYslabModal";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId: number;
    offerId: number;
    offerName: string;
    modalId: string;
    yslabProperty?: YslabProperty | null;
}

export const YslabPlanner3d = (props: Props) => {
    const plannerData = getPlanner3dData(props.offerId);
    const {openModal, closeModal, modalState} = useRoutedModalState(PLANNER_3D_SEARCH_PARAM, props.modalId);
    const {notSoldProperties} = useYslabPlannerPropertyData({offerId: props.offerId});
    const yslabHasProperties = notSoldProperties && notSoldProperties.length > 0;

    if (!plannerData || !yslabHasProperties) {
        return null;
    }

    return (
        <div className={props.className}>
            <div onClick={() => openModal()}>{props.children}</div>
            {modalState && (
                <YslabPlanner3dModal
                    modalState={modalState}
                    vendorId={props.vendorId}
                    offerId={props.offerId}
                    offerName={props.offerName}
                    modalId={props.modalId}
                    closeModal={closeModal}
                    yslabProperty={props.yslabProperty}
                />
            )}
        </div>
    );
};
import {ReactNode} from "react";

import {useRoutedModalState} from "../../../../hooks/use_routed_modal_state";
import {getPlanner3dData} from "../../../constants/get_planner_3d_data";
import {PLANNER_3D_SEARCH_PARAM} from "../../constants/planner_3d_params";
import {YslabProperty} from "./api/yslab_investments_api";
import {useYslabPlannerPropertyData} from "./hooks/use_yslab_planner_property_data";
import {YslabPlanner3dModal} from "./Planner3DYslabModal";

interface Props {
    className?: string;
    children: ReactNode;
    vendorId: number;
    offerId: number;
    offerName: string;
    modalId: string;
    yslabProperty?: YslabProperty | null;
}

export const YslabPlanner3d = (props: Props) => {
    const plannerData = getPlanner3dData(props.offerId);
    const {openModal, closeModal, modalState} = useRoutedModalState(PLANNER_3D_SEARCH_PARAM, props.modalId);
    const {notSoldProperties} = useYslabPlannerPropertyData({offerId: props.offerId});
    const yslabHasProperties = notSoldProperties && notSoldProperties.length > 0;

    if (!plannerData || !yslabHasProperties) {
        return null;
    }

    return (
        <div className={props.className}>
            <div onClick={() => openModal()}>{props.children}</div>
            {modalState && (
                <YslabPlanner3dModal
                    modalState={modalState}
                    vendorId={props.vendorId}
                    offerId={props.offerId}
                    offerName={props.offerName}
                    modalId={props.modalId}
                    closeModal={closeModal}
                    yslabProperty={props.yslabProperty}
                />
            )}
        </div>
    );
};
